export default __webpack_public_path__ + "static/media/cancer-ON.f13ca7c8.png";